module.exports = __webpack_public_path__ + "e841faf2273ea47794cb5d9e94818130.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/new-way.png
// module id = 674
// module chunks = 0